import { render } from "./DeliveryListModal.vue?vue&type=template&id=0c980d02&ts=true"
import script from "./DeliveryListModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryListModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__